// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"comment-content-view_shadow__kkkO7","text":"comment-content-view_text__ITHWv"};